module.exports = __webpack_public_path__ + "img/video-guwen.a5bc7d48.png";